/* np-wholesale.js: wholesale page (sections/new-wholesale.liquid).
   Shopify's contact form only echoes back form.name / form.email / form.body after a validation error, so the
   other contact[...] fields would come back empty. This saves them right before submit and, if the reload shows
   the error banner, restores them once. It never cancels the submit: the form always posts. */
(function () {
  var KEY = "npWholesaleFields";
  var form = document.getElementById("nws-form");
  if (!form) return;
  var keep = ["nws-business", "nws-phone", "nws-type", "nws-web", "nws-address", "nws-volume", "nws-source"];

  var saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch (e) { saved = null; }
  if (saved && document.getElementById("nws-form-error")) {
    keep.forEach(function (id) {
      var el = document.getElementById(id);
      if (el && saved[id]) el.value = saved[id];
    });
  }
  try { sessionStorage.removeItem(KEY); } catch (e) {}

  form.addEventListener("submit", function () {
    var data = {};
    keep.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) data[id] = el.value;
    });
    try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
  });
})();
